import { render, staticRenderFns } from "./ModalEditarOcorrencia.vue?vue&type=template&id=77387241&scoped=true"
import script from "./ModalEditarOcorrencia.vue?vue&type=script&lang=js"
export * from "./ModalEditarOcorrencia.vue?vue&type=script&lang=js"
import style0 from "./ModalEditarOcorrencia.vue?vue&type=style&index=0&id=77387241&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77387241",
  null
  
)

export default component.exports